import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';

import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { ILayoutsCatalog, ILayoutsCatalogState } from '../../types/layouts/layoutsCatalog';
import { selectJsonQuery } from '../../selectors/jsonQuery';
import { selectSubdomain } from '../../selectors/layoutsCatalog';
import {
  fetchGetLayoutsCatalog,
  TGetLayoutsCatalogResponse,
} from '../../repositories/newbuilding-search/v1/get-layouts-catalog';
import { layoutsStateMapper } from '../../utils/mappers/layoutsStateMapper';

interface IChangePageResult {
  layoutsCatalog: ILayoutsCatalogState;
}

const LAYOUTS_LIMIT = 4;

export const changePage = createAsyncThunk<IChangePageResult, number, IThunkApi>(
  'layouts/changePage',
  async (page, _thunkApi) => {
    const {
      extra: { httpApi, logger },
      rejectWithValue,
      getState,
    } = _thunkApi;

    const state = getState();

    const jsonQuery = selectJsonQuery(state);
    const subdomain = selectSubdomain(state);

    const parameters = {
      subdomain,
      jsonQuery,
      offset: (page - 1) * LAYOUTS_LIMIT,
      count: LAYOUTS_LIMIT,
    };

    try {
      const response: TGetLayoutsCatalogResponse = await fetchGetLayoutsCatalog({
        httpApi,
        parameters,
      });

      if (response.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: response.statusCode,
          message: 'Ошибка запроса в fetchGetLayoutsCatalog',
          domain: 'src/shared/thunks/layouts/changePage.ts',
        });
      }

      return {
        layoutsCatalog: layoutsStateMapper(response.response as ILayoutsCatalog),
      };
    } catch (err) {
      logger.error(err, {
        message: err.message,
        stack: err.stack,
        comment: 'Ошибка запроса в fetchGetLayoutsCatalog',
      });

      rejectWithValue(err);
    }

    return {
      layoutsCatalog: state.catalog,
    };
  },
);
